<template>
  <mavon-editor :class="withMaxHeight?'md':undefined" :value="value" @change="update"></mavon-editor>
</template>

<script>
export default {
  name: "MarkdownEdit",
  props: {
    value: String,
    withMaxHeight: Boolean
  },
  methods: {
    update(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.md.v-note-wrapper {
  max-height: 400px;
  &.fullscreen {
    max-height: 100% !important;
  }
}
</style>